import { render, staticRenderFns } from "./Nicknames-Admin.vue?vue&type=template&id=9a9fc4ca&scoped=true"
import script from "./Nicknames-Admin.js?vue&type=script&lang=js&external"
export * from "./Nicknames-Admin.js?vue&type=script&lang=js&external"
import style0 from "./Nicknames-Admin.vue?vue&type=style&index=0&id=9a9fc4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9fc4ca",
  null
  
)

export default component.exports